import type { BaseDataResponse, PaginatedListResponse } from "@/domain/dto/BaseDataResponse"
import type { BaseListResponseDTO } from "../dto/BaseListResponseDTO"
import type { BaseApiResponseDTO } from "../dto/BaseApiResponseDTO"

const toPaginatedListResponse = <T, R>(response: BaseListResponseDTO<R>, formattedListItems: T[]): PaginatedListResponse<T> => {
  return {
    status: response.status,
    data: formattedListItems,
    total: response.total,
    has_more_items: !!response.next_page_url,
    current_page: response.current_page
  }
}
const toResponseData = <T, R>(response: BaseApiResponseDTO<R>, data: T): BaseDataResponse<T> => {
  return {
    status: response.status,
    data,
  }
}
export default { toPaginatedListResponse, toResponseData }
